// Pick a readable text color (white or near-black) for a given background color.
// Uses the YIQ brightness approximation: cheap, stable, and good enough for UI
// labels. Threshold 150 keeps mid-yellows/greens on dark text where #fff fails.
//
// Reusable on purpose: this is the seed for the future app-wide palette work
// (FullCalendar appointments etc.) that currently assumes light backgrounds.

const DARK_TEXT = "#1f2430";
const LIGHT_TEXT = "#ffffff";

// "#rgb" | "rgb" | "#rrggbb" | "rrggbb" -> { r, g, b } | null
function parseHex(hex) {
  if (typeof hex !== "string") return null;
  let h = hex.trim().replace(/^#/, "");
  if (h.length === 3) {
    h = h
      .split("")
      .map((c) => c + c)
      .join("");
  }
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  };
}

export function readableTextColor(hex) {
  const rgb = parseHex(hex);
  if (!rgb) return DARK_TEXT;
  const yiq = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
  return yiq >= 150 ? DARK_TEXT : LIGHT_TEXT;
}

export default readableTextColor;
